/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Statsbar_Pricechanges72h2Inputs */

const id_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan Harga / 72 Jam`)
};

const ms_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan Harga / 72j`)
};

const da_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisændringer / 72t`)
};

const de_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisänderungen / 72h`)
};

const en_us2_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Changes / 72h`)
};

const es_es2_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios de precio / 72h`)
};

const es_mx2_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios de precio / 72h`)
};

const fil_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbabago ng Presyo / 72h`)
};

const fr_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changements de prix / 72h`)
};

const it_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiamenti prezzo / 72h`)
};

const hu_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árváltozások / 72 óra`)
};

const nl_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijsveranderingen / 72u`)
};

const no_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisendringer / 72t`)
};

const pl_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiany cen / 72h`)
};

const pt_br2_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações de Preço / 72h`)
};

const pt_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações de preço / 72h`)
};

const ro_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări preț / 72h`)
};

const fi_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnanmuutokset / 72h`)
};

const sv_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisändringar / 72h`)
};

const vi_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi giá / 72h`)
};

const tr_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat Değişiklikleri / 72s`)
};

const cs_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny cen / 72h`)
};

const bg_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени на цените / 72ч`)
};

const ru_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения цен за 72 часа`)
};

const uk_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змін цін / 72год`)
};

const ar_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيرات الأسعار / 72 ساعة`)
};

const hi_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य परिवर्तन / 72 घंटे`)
};

const th_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงราคา / 72 ชม.`)
};

const ja_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格変動 / 72時間`)
};

const zh_cn2_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`72小时价格变动`)
};

const zh_hant1_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`72小時價格變動`)
};

const ko_home_statsbar_pricechanges72h2 = /** @type {(inputs: Home_Statsbar_Pricechanges72h2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 변동 / 72시간`)
};

/**
* | output |
* | --- |
* | "Price Changes / 72h" |
*
* @param {Home_Statsbar_Pricechanges72h2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_statsbar_pricechanges72h2 = /** @type {((inputs?: Home_Statsbar_Pricechanges72h2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Statsbar_Pricechanges72h2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_statsbar_pricechanges72h2(inputs)
	if (locale === "ms") return ms_home_statsbar_pricechanges72h2(inputs)
	if (locale === "da") return da_home_statsbar_pricechanges72h2(inputs)
	if (locale === "de") return de_home_statsbar_pricechanges72h2(inputs)
	if (locale === "en-US") return en_us2_home_statsbar_pricechanges72h2(inputs)
	if (locale === "es-ES") return es_es2_home_statsbar_pricechanges72h2(inputs)
	if (locale === "es-MX") return es_mx2_home_statsbar_pricechanges72h2(inputs)
	if (locale === "fil") return fil_home_statsbar_pricechanges72h2(inputs)
	if (locale === "fr") return fr_home_statsbar_pricechanges72h2(inputs)
	if (locale === "it") return it_home_statsbar_pricechanges72h2(inputs)
	if (locale === "hu") return hu_home_statsbar_pricechanges72h2(inputs)
	if (locale === "nl") return nl_home_statsbar_pricechanges72h2(inputs)
	if (locale === "no") return no_home_statsbar_pricechanges72h2(inputs)
	if (locale === "pl") return pl_home_statsbar_pricechanges72h2(inputs)
	if (locale === "pt-BR") return pt_br2_home_statsbar_pricechanges72h2(inputs)
	if (locale === "pt") return pt_home_statsbar_pricechanges72h2(inputs)
	if (locale === "ro") return ro_home_statsbar_pricechanges72h2(inputs)
	if (locale === "fi") return fi_home_statsbar_pricechanges72h2(inputs)
	if (locale === "sv") return sv_home_statsbar_pricechanges72h2(inputs)
	if (locale === "vi") return vi_home_statsbar_pricechanges72h2(inputs)
	if (locale === "tr") return tr_home_statsbar_pricechanges72h2(inputs)
	if (locale === "cs") return cs_home_statsbar_pricechanges72h2(inputs)
	if (locale === "bg") return bg_home_statsbar_pricechanges72h2(inputs)
	if (locale === "ru") return ru_home_statsbar_pricechanges72h2(inputs)
	if (locale === "uk") return uk_home_statsbar_pricechanges72h2(inputs)
	if (locale === "ar") return ar_home_statsbar_pricechanges72h2(inputs)
	if (locale === "hi") return hi_home_statsbar_pricechanges72h2(inputs)
	if (locale === "th") return th_home_statsbar_pricechanges72h2(inputs)
	if (locale === "ja") return ja_home_statsbar_pricechanges72h2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_statsbar_pricechanges72h2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_statsbar_pricechanges72h2(inputs)
	return ko_home_statsbar_pricechanges72h2(inputs)
});
export { home_statsbar_pricechanges72h2 as "home.statsBar.priceChanges72h" }